<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { tagLabel } from '../utils/imovelShowFormatters';

defineProps({
  groupedDetailTabs: {
    type: Array,
    default: () => [],
  },
  statusLabel: {
    type: String,
    default: '',
  },
  listingTags: {
    type: Array,
    default: () => [],
  },
  houseDetailsLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['selectSection']);

const goToSection = section => emit('selectSection', section);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div
    class="border-b border-lais-border-soft bg-white px-4 py-3 sm:px-6 lg:px-10"
  >
    <div class="flex flex-wrap items-start gap-x-4 gap-y-3">
      <div
        v-for="group in groupedDetailTabs"
        :key="group.id"
        class="flex flex-col gap-1.5"
      >
        <span
          v-if="group.label"
          class="px-1 text-[10px] font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          {{ group.label }}
        </span>
        <div class="flex flex-wrap gap-2">
          <button
            v-for="section in group.tabs"
            :key="section.id"
            type="button"
            class="inline-flex min-h-10 items-center gap-2 rounded-lais-sm border px-3 py-2 text-[13px] font-semibold transition-colors"
            :class="
              section.active
                ? 'border-lais-primary bg-lais-primary-50 text-lais-primary'
                : 'border-lais-border bg-white text-lais-text-body hover:border-lais-primary hover:text-lais-primary'
            "
            @click="goToSection(section.id)"
          >
            <span class="size-4" :class="section.icon" aria-hidden="true" />
            {{ section.label }}
          </button>
        </div>
      </div>
    </div>
    <div class="mt-3 flex flex-wrap items-center gap-2">
      <span
        class="rounded-full bg-lais-primary-50 px-2.5 py-1 text-[11px] font-semibold text-lais-primary"
      >
        {{ statusLabel }}
      </span>
      <span
        v-for="tag in listingTags"
        :key="tag"
        class="rounded-full bg-lais-bg-soft px-2.5 py-1 text-[11px] font-semibold text-lais-text-body"
      >
        {{ tagLabel(tag) }}
      </span>
      <span v-if="houseDetailsLabel" class="text-[12px] text-lais-text-muted">
        {{ houseDetailsLabel }}
      </span>
    </div>
  </div>
</template>
